import { css } from "styled-components";

/*
 * Contorno dos modais de fundo PRETO — 22/09/2026.
 *
 * A área comum é escura e vários modais usam `neutral.black`, que é o mesmo
 * preto do fundo da página: sem contorno, os dois se fundem e não dá para saber
 * onde o modal começa e termina. O print do QA mostra exatamente isso — o
 * "Criar Conversa" parecia continuar página abaixo.
 *
 * ⚠️ Só a BORDA. Nada de `border-radius` aqui: alguns modais já definem o seu
 * (o de criar projeto usa 20px), e um valor no fragmento venceria ou perderia
 * conforme a ordem de aplicação — diferença silenciosa e chata de rastrear.
 * Quem quiser cantos arredondados continua declarando por conta.
 *
 * `box-sizing: border-box` é global (Styles/global.jsx), então os 2px da borda
 * não deslocam layout nenhum.
 *
 * NÃO use em modal de fundo claro: na área admin eles são brancos sobre um
 * overlay escuro e já estão delimitados por contraste.
 */
export const darkModalOutline = css`
  border: 1px solid ${({ theme }) => theme.colors.neutral.cinza500};
`;

export default darkModalOutline;
